import "core-js";
import React from "react";
import ReactDOM from "react-dom";
import { SnackbarProvider } from "notistack";
import OverlayScrollbars from "overlayscrollbars";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { createBrowserHistory } from "history";
import SimpleReactLightbox from "simple-react-lightbox";
import "jspdf/dist/polyfills.es.js";

import App from "./App";

import "./index.css";
import "overlayscrollbars/css/OverlayScrollbars.css";

const history = createBrowserHistory();
const environment = process.env.REACT_APP_API_URL === "https://api.dev.thevideovets.com/" ? "development" : "production";

Sentry.init({
    dsn: "https://da03348738dc41a988ae0defe69d70f1@o582084.ingest.sentry.io/5736356",
    integrations: [new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    })],
    environment: environment,
    tracesSampleRate: 1.0,
});


ReactDOM.render(
    <React.StrictMode>
        <SnackbarProvider
            anchorOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
            maxSnack={3}
            classes={{
                variantError: "snackbarError",
                variantSuccess: "snackbarSuccess",
            }}
        >
            <SimpleReactLightbox>
                <App />
            </SimpleReactLightbox>
        </SnackbarProvider>
    </React.StrictMode>,
    document.getElementById("root")
);


const overlay = OverlayScrollbars(document.body, {
    nativeScrollbarsOverlaid: {
        initialize: false
    }
});


const moveTidioToBody = () => {
    const tidio = document.querySelector('#tidio-chat');

    if (tidio && tidio.parentElement !== document.body) {
        document.body.appendChild(tidio);
    }
};


const observer = new MutationObserver(() => {
    moveTidioToBody();
});


observer.observe(document.body, {
    childList: true,
    subtree: true
});

moveTidioToBody();
